<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>쓰기 품질 향상 및 편집 워크
                            <br>플로우 개선</h1>
                        <p>일관성을 유지하는 글을 작성하고 보다 빠르게 출판하여 고객 경험을 향상시킬 수 있습니다. 명료함, 일관성, 브랜드 인식, 스타일을 희생하지 않고 편집 시간과 비용을
                            <br>동시에 절감할 수 있습니다.
                        </p>
                        <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">견적 문의</button>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/language-services-publishing-and-media.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>개별 맞춤형 솔루션
                        </h2>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="most_suited_point">
                        <ul>
                            <li>편집/교정 기업</li>
                            <li>미디어 및 출판사</li>
                            <li>블로거 웹사이트</li>
                            <li>번역 서비스 회사</li>
                            <li>프리프레스 하우스</li>
                            <li>마케팅 대행사</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>글로벌
                        <br>사용자</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/alternet.png" alt="alternate">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/HarperCollinsPublishers.png" alt="publisher">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/scholastic.png" alt="scholastic">
                                </div>
                            </div>
                            <!-- <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/RightlyWritten.png" alt="">
                                </div>
                            </div> -->
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/sanchini.png" alt="sanchini">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/technica.png" alt="technica">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/CapstoneWriting.png" alt="capston">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/evolution_editing.png" alt="editing">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>글쓰기 능력 향상을 위한 엔터프라이즈 기능</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카는 기업내 중요한 문서를 효율적으로 작성하는 동시에 품질을 보장하고 과학적 기록 규칙을 준수하도록 지원해 드립니다.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/BulkEditingOperations.svg" alt="bulk" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>대량 교정 작업</h3>
                                    <p>MS Word 형식으로 문서를 업로드하고 몇 분 안에 트링카가 문서를 교정합니다. 교정이 완료된 파일은 다운로드하여 모든 변경 사항을 검토하여 손쉽게 문서를
                                        완료할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/MedicalSpellCheckicon.svg" alt="medical" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>문맥에 맞는 맞춤법 검사 및 사전</h3>
                                    <p>트링카에 내장된 맞춤법 검사기는 ‘from’과 ‘form’의 차이를 아는 것은 물론 수백만 가지에 달하는 전문 어휘도 감지할 수 있습니다. 팀 구성원은
                                        각 사용자에 따라 개인 사전을 만들거나 하나의 공용 사전을 사용하여 브랜드에 관련한 모든 커뮤니케이션을 쉽게 유지할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/WordCountreductions.png" alt="word_count" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>단어 수 줄이기</h3>
                                    <p>트링카는 요점을 간결하게 전달하여, 전달한 메시지가 올바른 영향력을 발휘하도록 도와드립니다. 글을 쓰는 과정에서 팀이 배움을 얻기도 합니다!</p>
                                </div>
                            </div>

                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Suggestionsthatmatchyourtone.png" alt="suggestions" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>어조에 맞는 제안</h3>
                                    <p>트링카 AI는 일반 문서와 포멀한 문서를 구분하여 해당 문서에 적합한 언어로 제안합니다. 연구 문서의 경우 원본 연구 및 리뷰, 사례 보고서까지 다양한
                                        유형으로 설정할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/EasyUserManagement.svg" alt="easy user" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>쉬운 사용자 관리</h3>
                                    <p>팀 계정을 사용하면 구성원을 쉽게 추가하거나 제거할 수 있습니다. 실시간으로 크레딧 및 사용 한도를 관리해 보세요. 그 대상이 팀원이든 아웃소싱한 인재이든, 트링카의 세분화된 제어 기능을 통해 액세스를 쉽고 안전하게 관리할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt="ppc" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>표절 검사 </h3>
                                    <p>가장 진보된 텍스트 유사도 탐지 알고리즘인 iThenticate와 최대 규모의 유료 출판 데이터베이스를 통해 최고 품질의 표절 검사를 제공합니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ComprehensiveAnalytics.svg" alt="analytics" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>종합 분석</h3>
                                    <p>효과적인 의사 결정을 위해 팀에서 트링카 사용방법 또는 풍부한 분석 기능을 사용하여 각 사용자의 활동을 상세하게 분석할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/DedicatedSupport.svg" alt="Dedicated_Support" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>전담 지원</h3>
                                    <p>전담 매니저가 배정되어 전화, 문서, 그리고 영상 등을 통해 트링카를 최대한 활용할 수 있도록 지원합니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <span class="bottom_diviedLine"></span>
                    <span class="bottom_diviedLine1"></span>

                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>다양한 사용 사례 지원</h2>
                    <div class="HeadingSubLine"></div>
                    <p>특정 산업 및 역할에 맞는 사용 사례를 통해 트링카가 의학 글쓰기에서 발휘하는 진정한 위력을 알아보세요.</p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>콘텐츠 편집자를 위한 강력한 지원</h4>
                                <p>트링카는 문법과 난해한 기계적 문제를 수정하여 전문 편집자가 의미론과 전달에 집중하도록 도와드립니다. 이를 통해 출력 품질을 향상하고 워크플로를 간소화할 수 있습니다.</p>
                                <ul>
                                    <li>프로젝트 처리 시간 개선</li>
                                    <li>편집 품질 향상</li>
                                    <li>출판 시간 단축</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>마케팅 팀을 위한 지원</h4>
                                <p>트링카의 정밀한 제안을 통해 팀은 더욱 개선된 고객 이메일, 마케팅 자료, 커뮤니케이션, 보고서, 프레젠테이션 등을 창출할 수 있습니다.</p>
                                <ul>
                                    <li>고객 커뮤니케이션 중 당혹스러운 실수 방지</li>
                                    <li>손쉽게 브랜드와 요점 유지</li>
                                    <li>콘텐츠 전달 시간 단축</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>편집 품질 평가 지원</h4>
                                <p>트링카의 글쓰기 평가 AI는 사용자 지정 가능한 점수와 카테고리별 오류 정리를 통해 유용한 통찰을 제공해 드립니다.</p>
                                <ul>
                                    <li>품질에 대한 양적 통찰</li>
                                    <li>편집 인력 채용 지원</li>
                                    <li>설명과 팁을 동반한 학습 기회</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>번역 후 문법 자동 검사</h4>
                                <p>번역 팀이 트링카를 사용하면 정밀한 문법 수정을 통해 영어 번역을 개선하고 양질의 통찰을 얻을 수 있습니다.</p>
                                <ul>
                                    <li>문맥에 맞는 맞춤법 검사</li>
                                    <li>기술적 구문 표현 및 문장 구조 개선</li>
                                    <li>대용량 처리 워크플로를 위한 자동 파일 편집</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>독점 소프트웨어 및 작업 흐름에 따른 통합</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>트링카의 손쉬운 통합으로 기존 소프트웨어 내에 있는 모든 혜택을 같이 누릴 수 있어 글 작성이 보다 효과적이고 생산적이게 이루어집니다.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>자바스크립트</h3>

                    <p>
                        브라우저나 애플리케이션에 작은 자바스크립트(JS) 코드 스니펫을 삽입하기만 하면 모든 팀 구성원이 트링카를 사용할 수 있습니다.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>API</h3>
                    <p>
                        트링카의 강력한 API는 기존 애플리케이션에서 트링카를 바로 사용하도록 도와드립니다. 간단한 API 아키텍처를 통해 손쉽게 통합 작업을 할 수 있습니다.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>온프레스미스
                        <span>(직접 설치)</span>
                    </h3>
                    <p>로컬 서버와 클라우드 서버를 막론하고 공공 기반 시설에서 트링카를 통해 효과적인 기록과 최대한의 기밀유지가 보장됩니다.
                    </p>

                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>클라우드 에디터</h3>
                    <p>
                        안전한 웹 기반 어플리케이션으로 언제 어디서나 트링카의 잠재 능력을 최대한 활용할 수 있습니다.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>MS Word 추가 기능</h3>
                    <p>
                        MS Word로 전달되는 글 작성 팁 제안으로 팀의 생산성을 높여보세요.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>브라우저 플러그인</h3>
                    <p>
                        즐겨 사용하는 모든 브라우저에 적합한 플러그인을 통해 모든 웹사이트에서 실시간 글쓰기 지원을 받아보세요.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>귀사에 적합한 맞춤형 비용</h2>
                </div>
                <p>트링카는 고객 고유의 요구사항에에 맞게 개별 사용자 또는 사용 용도에 따른 비용을 책정합니다.
                    <br>추가 비용 없이 사용자를 변경하고 사용 제한을 실시간으로 적용할 수 있습니다.
                    <br>고객과 협력하여 주문서 및 인보이스를 통해 개별 맞춤형 계약 및 단일 결제 옵션이 제공될 수 있도록 협력합니다.
                </p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">Get a Quote</a> -->

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">견적 문의</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>안전, 보안, 신뢰</h3>
                        <p>트링카는 데이터 보안과 개인 정보 보호를 최우선으로 생각합니다. 내 모든 데이터는 강력하게 암호화되어 안전하게 저장됩니다. 다른 사람은 내 데이터에 액세스할 수 없습니다.
                            <br>트링카는 글쓰기 제안을 받으면 데이터 저장을 제거하는 고유한 플랜을 제공해 드립니다.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="safe-secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="AI" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>AI 소개</h3>
                        <p>트링카는 최신 머신러닝(ML) 및 자연어 처리(NLP) 기술을 사용하여 문법 오류를 식별하고 언어 향상을 제안합니다. 의학, 생명과학, 생물학, 물리학, 공학, 인문학, 비즈니스
                            및 예술을 포함한 1300개 이상의 주제 영역을 망라하며 모범적으로 작성된 논문 및 기사 수백만 건을 바탕으로 훈련되기에 해당 주제에 가장 적절한 제안을 제공합니다.</p>
                        <p>트링카는 장벽 없는 커뮤니케이션을 통해 미래를 만들어가고자 하는 깊은 열망을 품은
                            <br>언어학자, 의학 에디터, 데이터 과학자 및 엔지니어로 이루어진 팀이 개발했습니다.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>트링카로 비즈니스 커뮤니케이션을 혁신해 보세요</p>
    <button data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">견적 문의</button>
</div>

<app-enterprise-modal></app-enterprise-modal>